<app-uni-page [parent]="this" pageTitle="Returns" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"/>

<ng-template #bodyTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">
    <div class="qb-list-actions flex items-center gap-3">
      <span class="font-semibold">Active returns: {{ rrds.length }}</span>
      <span class="text-muted text-sm">— filter by Phase or any other column to narrow the list.</span>
    </div>

    <app-ag-grid
      [gridOptions]="gridOptions"
      [rowData]="rrds"
      class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" (click)="goBack()"><span>Go Back</span></button>
  </div>
</ng-template>
